import script from "./FormElementFile.vue?vue&type=script&setup=true&lang=js"
export * from "./FormElementFile.vue?vue&type=script&setup=true&lang=js"

import "./FormElementFile.vue?vue&type=style&index=0&id=819ebaee&lang=scss"

const __exports__ = script;

export default __exports__